module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-undo-ac2fd015f2f67ce5c5bb518963684efd.svg";